module.exports = __webpack_public_path__ + "5c114213/img/upload-icon.9179ae4e.svg";